import WPhoto_NewPolaroidPhotoComponent from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/skinComps/NewPolaroidPhoto/NewPolaroidPhoto.skin';
import WPhoto_NewPolaroidPhotoController from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/WPhoto.controller';


const WPhoto_NewPolaroidPhoto = {
  component: WPhoto_NewPolaroidPhotoComponent,
  controller: WPhoto_NewPolaroidPhotoController
};


export const components = {
  ['WPhoto_NewPolaroidPhoto']: WPhoto_NewPolaroidPhoto
};

